import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import { RootState } from "../../../store/Index";
import muzukurulogo from "../../../assets/muzukurublack.png";
import Button from "../../../components/ui/Button";

const Footer: React.FC = () => {
  const theme = useTheme();
  const themeState = useSelector((state: RootState) => state.theme);
  const colors = tokens(theme.palette.mode, themeState);
  const navigate = useNavigate();

  const handleContactSupport = () => {
    console.log("Contact Support clicked");
    // TODO: Open support form or navigate to support page
  };

  const handleSalesInquiry = () => {
    console.log("Sales Inquiries clicked");
    // TODO: Open sales form or navigate to sales page
  };

  const handleLinkClick = (link: string) => {
    if (link === "Privacy Policy") {
      navigate("/privacy-policy");
      return;
    }
    if (link === "Terms of Service") {
      navigate("/terms-of-service");
      return;
    }
    console.log(`${link} clicked`);
    // TODO: Navigate to respective page
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: colors.primary[400],
        color: colors.primary[900],
        py: 8,
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: 2, sm: 3, lg: 4 },
        }}
      >
        {/* Top Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            pb: 6,
            mb: 6,
            borderBottom: `1px solid ${colors.primary[100]}`,
          }}
        >
          {/* Left - Logo & Description */}
          <Box sx={{ mb: { xs: 4, md: 0 } }}>
            <Box
              component="img"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              src={muzukurulogo}
              alt="Muzukuru logo"
              sx={{
                width: { xs: "140px", sm: "160px", md: "161px" },
                height: "auto",
                cursor: "pointer",
              }}
            />

            <Typography
              sx={{
                color: `${colors.primary[900]}70`,
                maxWidth: "400px",
                fontSize: "0.875rem",
              }}
            >
              Dignity, innovation, and partnership in funeral assurance
              technology.
            </Typography>
          </Box>

          {/* Right - Action Buttons */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              variant="outlined"
              onClick={handleContactSupport}
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 2,
                fontSize: "0.875rem",
                fontWeight: 700,
                textTransform: "none",
                borderColor: `${colors.primary[900]}10`,
                color: colors.primary[900],
                bgcolor: `${colors.primary[900]}10`,
                "&:hover": {
                  borderColor: `${colors.primary[900]}20`,
                  bgcolor: `${colors.primary[900]}20`,
                },
              }}
            >
              Contact Support
            </Button>
            <Button
              variant="contained"
              onClick={handleSalesInquiry}
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 2,
                fontSize: "0.875rem",
                fontWeight: 700,
                textTransform: "none",
              }}
            >
              Sales Inquiries
            </Button>
          </Stack>
        </Box>

        {/* Bottom Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 2,
          }}
        >
          {/* Copyright */}
          <Typography
            sx={{
              fontSize: "0.75rem",
              color: `${colors.primary[900]}60`,
              fontWeight: 600,
            }}
          >
            © {new Date().getFullYear()} Muzukuru Streaming Services. All rights
            reserved.
          </Typography>

          {/* Links */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 4 }}
          >
            {["Privacy Policy", "Terms of Service", "SLA Compliance"].map(
              (link, index) => (
                <Typography
                  key={index}
                  onClick={() => handleLinkClick(link)}
                  sx={{
                    fontSize: "0.75rem",
                    color: `${colors.primary[900]}60`,
                    fontWeight: 600,
                    cursor: "pointer",
                    transition: "color 0.3s ease",
                    "&:hover": {
                      color: colors.primary[900],
                    },
                  }}
                >
                  {link}
                </Typography>
              ),
            )}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
